<base-index-page
  [config]="baseIndexPageConfig"
  [service]="regulatorsService"
  [idKey]="'scanId'">

  <regulator-context-box [items]="contextItems" (back)="goBack()" />

</base-index-page>
